import axios from "axios";
import { Response } from "../../../../../shared/models/Response";
import { Http } from "@status/codes";
import { ChatResponse } from "../Model/ChatResponse.mdoel";
export class ChatService {
  private baseUrl: string;
  constructor() {
    this.baseUrl = `${process.env.VUE_APP_CHAT_API}/chat`;
  }
  async sendChatProp(prop: string, threadId?: string, assitantId?: string) {
    const response: Response<ChatResponse> = {
      code: 0,
      message: ""
    };
    const userInput = prop || "";
    if (userInput.trim().length === 0) {
      response.code = Http.BadRequest;
      response.message = "";
      return response;
    }
    try {
      const responseChat = await axios.post(`${this.baseUrl}/completion`, {
        input: prop,
        threadId: threadId,
        assistantId: assitantId
      });
      return responseChat.data as Response<ChatResponse>;
    } catch (error) {
      response.code = Http.Forbidden;
      return response;
    }
  }
}
